import classNames from 'classnames';
import { Link, Text } from '@nerdwallet/currency';
import P from 'prop-types';
import {
  setTrk,
  TrkTag,
  TrkElement,
} from '@nerdwallet/nw-client-lib/trk-helper';
import Image from '@nerdwallet/react-image';
import styles from './keto-product-card.module.scss';

import UniversalContainer, {
  universalContainerPropTypes,
} from '../universal-container';

const WhyNerdsLoveIt = ({
  container,
  turnOnGroupedBorders,
  whyNerdsLoveItTitle,
  whyNerdsLoveItTitleIconUrl,
  whyNerdsLoveItText,
  whyNerdsLoveItMethodologyUrl,
  productId,
  whyNerdsLoveItAvatarUrl,
}) => {
  const containerProps = {
    ...container,
    ...(!container?.backgroundColor && {
      backgroundColor: 'HEXCOLOR',
      hexColor: '#f2fbff',
    }),
  };
  return (
    <UniversalContainer {...containerProps}>
      <div
        className={classNames([
          styles.whyNerdsLoveIt,
          { [styles.whyNerdsLoveItBorder]: turnOnGroupedBorders },
        ])}
      >
        <div
          className={classNames([
            styles.whyNerdsLoveItAvatar,
            { [styles.fixEmptyAvatarPadding]: !whyNerdsLoveItAvatarUrl },
          ])}
        >
          {whyNerdsLoveItAvatarUrl && (
            <Image
              src={whyNerdsLoveItAvatarUrl}
              alt="why nerds love it icon"
              backgroundColor="transparent"
            />
          )}
        </div>
        <div>
          <Text component="h4" className="whyNerdsLoveItTitle">
            {whyNerdsLoveItTitle || 'WHY OUR NERDS LOVE IT'}
            {whyNerdsLoveItTitleIconUrl && (
              <Image
                src={whyNerdsLoveItTitleIconUrl}
                alt="why nerds love it icon"
                backgroundColor="transparent"
              />
            )}
          </Text>
          <Text component="p">{whyNerdsLoveItText}</Text>
          <Link
            className={styles.whyNerdsLoveItTextLink}
            target="_blank"
            href={setTrk({
              url: whyNerdsLoveItMethodologyUrl,
              params: {
                [TrkTag.copy]: 'Read our methodology',
                [TrkTag.element]: TrkElement.hyperlink,
                [TrkTag.location]: 'KetoProductCard__whyThisProduct',
                trk_productId: productId,
              },
            })}
          >
            Read our methodology &#10095;
          </Link>
        </div>
      </div>
    </UniversalContainer>
  );
};

WhyNerdsLoveIt.propTypes = {
  container: universalContainerPropTypes,
  whyNerdsLoveItTitle: P.string,
  whyNerdsLoveItTitleIconUrl: P.string,
  whyNerdsLoveItText: P.string,
  whyNerdsLoveItMethodologyUrl: P.string,
  productId: P.string,
  turnOnGroupedBorders: P.bool,
  whyNerdsLoveItAvatarUrl: P.string,
};

export default WhyNerdsLoveIt;
